export default __webpack_public_path__ + "static/media/Glodani 3.a22bd9ee.jpg";